var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Type } from './Type';
import { Int } from './Int';
var Enum = /** @class */ (function (_super) {
    __extends(Enum, _super);
    function Enum(values) {
        var _this = _super.call(this) || this;
        _this._values = values;
        _this._int = new Int(0);
        return _this;
    }
    Enum.prototype.encodeBuffer = function (value, buffer) {
        var index = this._values.indexOf(value);
        if (index === -1) {
            throw new TypeError('Unexpected value of enum');
        }
        this._int.encodeBuffer(index, buffer);
    };
    Enum.prototype.decodeBuffer = function (buffer) {
        return this._values[this._int.decodeBuffer(buffer)];
    };
    return Enum;
}(Type));
export { Enum };
